/* eslint-disable no-unused-vars */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import PageTitle from './layout/PageTitle';

export default function ListUsers() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  useEffect(() => {
    getUsers();
  }, []);

  function getUsers() {
    axios.get('https://filenamebuilder.com/api/users.php').then(function (response) {
      setUsers(response.data);
    });
  }

  const deleteUser = (id) => {
    axios.delete(`https://filenamebuilder.com/api/users.php/${id}`).then(function (response) {
      getUsers();
    });
  };

  return (
    <>
      <PageTitle title="Users" />
      <Container>
        <Row>
          <Col className="text-end">
            <p>
              <Button onClick={() => navigate('/user/create')}>Create New</Button>
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Projects</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, key) => (
                  <tr key={key}>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      <Button size="sm" onClick={() => navigate(`../projects/${user.id}`)}>
                        View Projects
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" onClick={() => navigate(`../user/${user.id}/edit`)}>
                        Edit
                      </Button>
                      &nbsp;
                      <Button size="sm" onClick={() => deleteUser(user.id)}>
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  );
}
